module.exports = __webpack_public_path__ + "img/logo.70f55e55.png";